module.exports = __webpack_public_path__ + "static/media/aldi2.8a3dc0c7.jpg";